import { useTranslations } from 'next-intl'
import Image from 'next/image'

interface ProductInfoFreeshipProps {
  price: number
}

export const ProductInfoFreeship = ({ price }: ProductInfoFreeshipProps) => {
  const isFreeship = price >= 200000
  const t = useTranslations('product_detail.title')

  return (
    <div className='mt-1 flex items-center justify-between'>
      <div className='flex items-center gap-2 text-sm'>
        <Image
          src={'https://www.coolmate.io/images/icons/icon4.svg'}
          alt={t('freeship')}
          width={18}
          height={18}
        />
        <span>
          Freeship
          {!isFreeship ? t('freeship_condition') : null}
        </span>
      </div>
    </div>
  )
}
